import { signIn } from '@/api/member'
import { setAuthData, setLoginId, getLoginId, removeLoginId } from '@/libs/auth-helper'
import store from '@/store'

export const memberMixin = {
    computed: {
        canSubmit() {
          return this.model.memId && this.model.memPass
        },
        loginId() {
          return getLoginId();
        }
      },
      watch: {
        loginId: {
          handler(loginId) {
            if (loginId) {
              this.saveId = true
              this.model.memId = loginId
            } else this.saveId = false
          },
          immediate: true
        }
      },
      data() {
        return {
          model: {
            memId: '',
            memPass: ''
          },
          saveId: false
        }
      },
      methods: {
        // 로그인 팝업 닫기
        loginClosePopupMask(e) {
          const target = e.target
          const filter = target.classList.contains('popup_mask')
          if (filter) {
            this.closeLogin()
          }
        },
        // 로그인 팝업 닫기
        closeLogin() {
          this.$emit('close', 'signin')
        },
        // 로그인
        onSubmit() {
          if (this.model.memId === '') {
            this.onAlert('warningart', 'front.signin.emptyMemId')
            return
          }
          if (this.model.memPass === '') {
            this.onAlert('warningart', 'front.signin.emptyMemPass')
            return
          }
          if (!this.canSubmit) {
            return
          }
          signIn(this.model).then(async response => {
              console.log(response)
            const result = response.data
            const data = result.data
            if (result.resultCode === '200') {
              setAuthData(data)
              store.commit('setUserData', data.member)
              store.dispatch('storeCommonCode').then(commonCode => {
                if (data.msgInfo) {
                  store.dispatch('storeUserUnReadMessageCount', data.msgInfo.newMsg)
                }
                if(this.saveId) {
                  setLoginId(this.model.memId)
                }else {
                  removeLoginId()
                }
                this.closeLogin()
              })
            } else {
              await this.onCheck(this.$t(`api.${result.resultCode}`))
            }
          }).catch(async err => {
            console.error('login err : ', err.message)
            console.log(err)
          })
        }
      }
}
